module.exports = __webpack_public_path__ + "a1ffc99e23f9dc49e100e03c3f816b65.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/menu/language.svg
// module id = 166
// module chunks = 0